
import { defineComponent, ref } from "vue";
import agency from "@/views/pages/other/agency/agency.vue";
import { translate } from "@/core/services/HelpersFun";
export default defineComponent({
  name: "kt-cooperationInSaleDesc",
  components: { agency },
  setup() {
    const activeName = ref("");

    return {
      activeName,
      translate,
    };
  },
});
